/**
 * Navigation utility functions for secure routing and path validation
 */

/**
 * Validates a returnTo path to prevent open redirect vulnerabilities.
 *
 * Security requirements:
 * - Only accept relative paths that start with /
 * - Reject absolute URLs (http://, https://)
 * - Reject protocol-relative URLs (//)
 * - Reject undefined, null, or empty strings
 *
 * @param path - The path to validate
 * @returns The validated path if safe, otherwise null
 */
export function validateReturnToPath(
  path: string | undefined | null
): string | null {
  // Reject undefined, null, or empty strings
  if (!path || typeof path !== 'string' || path.trim() === '') {
    return null;
  }

  const trimmedPath = path.trim();

  // Reject absolute URLs (http://, https://, etc.)
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(trimmedPath)) {
    return null;
  }

  // Reject protocol-relative URLs (//)
  if (trimmedPath.startsWith('//')) {
    return null;
  }

  // Only accept paths that start with /
  if (!trimmedPath.startsWith('/')) {
    return null;
  }

  return trimmedPath;
}
